import { render, staticRenderFns } from "./RegisterLessonBasic.vue?vue&type=template&id=a0f2b2a6&scoped=true&"
import script from "./RegisterLessonBasic.vue?vue&type=script&lang=js&"
export * from "./RegisterLessonBasic.vue?vue&type=script&lang=js&"
import style0 from "./RegisterLessonBasic.vue?vue&type=style&index=0&id=a0f2b2a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f2b2a6",
  null
  
)

export default component.exports